export default __webpack_public_path__ + "static/media/gallery - potions_09.781421af.jpg";